export default __webpack_public_path__ + "static/ActuImage-040dc8aab6c708c902b4b84bdb0a6a4a.jpg";